export default __webpack_public_path__ + "static/upfactor_a1_cloud_testimonial_preview-b1e6ed80998723b69f59c3be25d76e63.webp";